<div class="container py-0 py-lg-3">
  <app-line-chart [data]="lineChartData" [titleArray]="['Total Inventory']" [valueFields]="['totalInventory']"
    [hideLegend]="true" [categoryField]="'hour'" [dataDateFormat]="'MM-DD-YYYY JJ:NN:SS'"
    [categoryBalloonDateFormat]="'YYYY-MM JJ:NN'" [minPeriod]="'hh'" graphFillColors="#EAF6ED" graphLineColor="#4BC47C">
  </app-line-chart>

  <div class="row px-0 p-lg-3">
    <div class="col-4 col-lg-6">
      <span class="label mr-1">Peak Active Hour</span>
      <info-tooltip2 key="Peak Active Hour"></info-tooltip2>
    </div>
    <div class="col col-lg-6 text-right ml-auto mr-4 mr-lg-0"><span class="value">
        {{data?.engagementMetrics?.peakHourOfDay | timeformat:'24hr'}}</span>
    </div>
  </div>
  <div class="row pb-3 px-lg-3">
    <div class="col-4 col-lg-6">
      <span class="label mr-1">Peak Active Day</span>
      <info-tooltip2 key="Peak Active Day"></info-tooltip2>
    </div>
    <div class="col col-lg-6 text-right ml-auto mr-4 mr-lg-0"><span class="value">
        {{data?.engagementMetrics?.peakDayOfWeek | timeformat:'dayOfWeek'}}</span>
    </div>
  </div>
</div>